import request from '@/utils/request'

export function getImportantNoticeApi(type: number) {
  return request<string>({
    url: 'important-notice/getOne',
    method: 'get',
    params: {
      type,
    },
  })
}
